import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../../services/media-query.service';

@Component({
  selector: 'td-wb-mobile-toolbar',
  templateUrl: 'mobile-toolbar.component.html',
  styleUrls: ['mobile-toolbar.component.scss'],
  imports: [
    AsyncPipe
  ],
  host: {
    '[class.td-wb-mobile-toolbar]': 'toolbarClass'
  }
})
export class MobileToolbarComponent {
  private readonly mediaQueryService = inject(MediaQueryService);

  toolbarClass: boolean = true;

  breakpointChanges$: Observable<BreakpointState>;

  constructor() {
    this.breakpointChanges$ = this.mediaQueryService.observe(Breakpoint.SM, Breakpoint.MD);
  }
}
